var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseNav',{attrs:{"nav_text":['Home', 'Teachers', 'Students', 'Report App'],"nav_icon":[
      'icon-tachometer',
      'icon-teacher',
      'icon-parent-child',
      'icon-library' ],"nav_name":[
      'SchoolDashboard',
      'SchoolDashboardTeacher',
      'SchoolDashboardStudent',
      'FalseReportApp' ],"nav_type":"school","show_nav":true}}),_c('MobileTopNav',{attrs:{"nav_type":"school"}}),_c('MobileBaseNav',{attrs:{"nav_text":['Home', 'Teachers', 'Students', 'Report App'],"nav_icon":[
      'icon-tachometer',
      'icon-teacher',
      'icon-parent-child',
      'icon-library' ],"nav_name":[
      'SchoolDashboard',
      'SchoolDashboardTeacher',
      'SchoolDashboardStudent',
      'FalseReportApp' ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }